module.exports = __webpack_public_path__ + "img/icon-5.1b785f68.svg";